import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import * as HrActions from '../../../store/actions/hr.action';
import ConfirmationModal from '../../../shared/components/ui/modal/confirmation-modal';

export default {
  action: (id: string, status: string) => {
    const dispatch = useDispatch();
    const [modalOpen, setModalOpen] = useState<boolean>(false);

    const onDeleteHandler = () => {
      setModalOpen(true);
    };

    const onModalAction = async (e: string) => {
      if (e === 'confirm') {
        if (id) dispatch(HrActions.HrDeleteApprover(id));
        setModalOpen(false);
      } else {
        setModalOpen(false);
      }
    };

    return (
      <>
        {(status === 'ongoing' || status === 'created') && (
          <IconButton onClick={onDeleteHandler} color='primary' sx={{ mr: '.25rem' }}>
            <DeleteIcon />
          </IconButton>
        )}

        <ConfirmationModal
          isModalOpen={modalOpen}
          title={'Confirmation'}
          message={'Do you want to delete this signatory on this application?'}
          onClickModal={(e: string) => onModalAction(e)}
        />
      </>
    );
  },
};
